import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Paragraph from 'components/Paragraph';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Stats = ({ currentSearchValue, searchResultStats }) => {
  if (isNil(currentSearchValue) || currentSearchValue == '') {
    return null;
  }

  const getStastMessage = () => {
    let statsMessage = null;

    if (searchResultStats?.errorOnSearch) {
      statsMessage = I18n.localize('searchBar.errorResult');
    } else if (searchResultStats?.totalItemsSearched !== 0) {
      statsMessage = I18n.localize('searchBar.showingCountResultsForQuery', {
        count: searchResultStats?.totalItemsSearched,
        value: currentSearchValue,
      });
    } else {
      statsMessage = I18n.localize('searchBar.noResults', { value: currentSearchValue });
    }

    return statsMessage;
  };

  return (
    <div className="Stats">
      <Paragraph role="status">{getStastMessage()}</Paragraph>
      <style jsx>{`
        .Stats {
          margin-bottom: ${Theme.get('spacing') * 3}px;
        }
      `}</style>
      <style jsx global>{`
        .Stats .Sub {
          color: ${Theme.get('colors-black-80')};
        }
      `}</style>
    </div>
  );
};

Stats.propTypes = {
  currentSearchValue: PropTypes.string,
  searchResultStats: PropTypes.shape({
    totalItemsSearched: PropTypes.number,
    errorOnSearch: PropTypes.bool,
  }),
};

Stats.defaultProps = {
  currentSearchValue: undefined,
  searchResultStats: PropTypes.shape({
    totalItemsSearched: 0,
    errorOnSearch: false,
  }),
};

export { Stats };
